/** InsCoder WANG.J 2026-08-17 B + Why Shop at Ogee scroll reveal behavior **/
(function () {
  'use strict';

  var selector = '[data-cust-why-shop-ogee-gallery]';
  var instances = new WeakMap();

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function lerp(start, end, progress) {
    return start + (end - start) * progress;
  }

  function easeInOutCubic(progress) {
    return progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;
  }

  function numberFrom(card, key) {
    return parseFloat(card.dataset[key]) || 0;
  }

  function createInstance(root) {
    if (!root || instances.has(root)) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cust-why-card]'));
    var head = root.querySelector('[data-cust-why-head]');
    var heading = root.querySelector('[data-cust-why-heading]');
    var veil = root.querySelector('[data-cust-why-veil]');
    var revealContainer = root.querySelector('[data-cust-why-reveal]');
    var details = root.querySelector('[data-cust-why-details]');
    var actions = root.querySelector('[data-cust-why-actions]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var frame = 0;

    function reveal(element, progress) {
      if (!element) return;
      element.style.opacity = progress.toFixed(4);
      element.style.transform = 'translateY(' + lerp(14, 0, progress).toFixed(3) + 'px)';
    }

    function render() {
      frame = 0;

      var rect = root.getBoundingClientRect();
      var travel = Math.max(root.offsetHeight - window.innerHeight, 1);
      var rawProgress = reducedMotion.matches ? 1 : clamp(-rect.top / travel, 0, 1);
      var progress = easeInOutCubic(rawProgress);
      var viewportWidth = window.innerWidth;
      var endOverflow = viewportWidth < 576 ? 1.2 : 1;
      var endScaleMultiplier = viewportWidth < 576 ? 0.78 : 1;
      var startSpreadMultiplier = viewportWidth >= 990 ? 1.35 : viewportWidth < 576 ? 1.45 : 1.25;
      var startVerticalMultiplier = viewportWidth >= 990 ? 1.2 : viewportWidth < 576 ? 2 : 1.6;
      var detailsProgress = clamp((rawProgress - 0.42) / 0.22, 0, 1);
      var actionsProgress = clamp((rawProgress - 0.56) / 0.22, 0, 1);
      var revealVisible = reducedMotion.matches || detailsProgress > 0 || actionsProgress > 0;

      if (revealContainer) {
        revealContainer.setAttribute('aria-hidden', revealVisible ? 'false' : 'true');
      }

      cards.forEach(function (card) {
        var startX = numberFrom(card, 'sx') * Math.min(viewportWidth, card.offsetWidth * 4.2) * startSpreadMultiplier;
        var startY = numberFrom(card, 'sy') * window.innerHeight * startVerticalMultiplier;
        var finalX = numberFrom(card, 'fx') * viewportWidth * endOverflow;
        var finalY = numberFrom(card, 'fy') * window.innerHeight;
        var startRotation = numberFrom(card, 'sr');
        var finalRotation = numberFrom(card, 'fr');
        var startScale = numberFrom(card, 'ss');
        var finalScale = numberFrom(card, 'fs') * endScaleMultiplier;

        var x = lerp(startX, finalX, progress);
        var y = lerp(startY, finalY, progress);
        var rotation = lerp(startRotation, finalRotation, progress);
        var scale = lerp(startScale, finalScale, progress);

        card.style.transform = 'translate(-50%, -50%) translate3d(' + x.toFixed(3) + 'px, ' + y.toFixed(3) + 'px, 0) rotate(' + rotation.toFixed(3) + 'deg) scale(' + scale.toFixed(4) + ')';
      });

      if (head) {
        var headProgress = clamp(rawProgress / 0.22, 0, 1);
        var headOffset = clamp(viewportWidth * 0.08, 32, 100);
        var collapsedCompensation = heading ? Math.max((head.offsetHeight - heading.offsetHeight) / 2, 0) : 0;
        var startHeadY = collapsedCompensation - headOffset;
        var expandedCenterProgress = clamp((rawProgress - 0.42) / 0.4, 0, 1);
        var expandedHeadShift = 0;

        if (revealVisible && revealContainer) {
          var naturalCenterShift = (revealContainer.offsetHeight + 24) / 2;
          var finalCenterShift = viewportWidth < 576
            ? naturalCenterShift
            : Math.min(naturalCenterShift, window.innerHeight * 0.12);
          expandedHeadShift = finalCenterShift * expandedCenterProgress;
        }

        var currentHeadY = lerp(startHeadY, 0, headProgress) - expandedHeadShift;
        head.style.transform = 'translate(-50%, -50%) translate3d(0, ' + currentHeadY.toFixed(3) + 'px, 0)';
      }

      if (veil) {
        var veilProgress = clamp((rawProgress - 0.08) / 0.24, 0, 1);
        veil.style.opacity = veilProgress.toFixed(4);
        veil.style.transform = 'scale(' + lerp(0.96, 1, veilProgress).toFixed(4) + ')';
      }

      reveal(details, detailsProgress);
      reveal(actions, actionsProgress);

      if (actions) {
        var actionsVisible = reducedMotion.matches || actionsProgress > 0.95;
        actions.style.pointerEvents = actionsVisible ? 'auto' : 'none';
        actions.toggleAttribute('inert', !actionsVisible);
        actions.setAttribute('aria-hidden', actionsVisible ? 'false' : 'true');
      }

      root.dataset.motionProgress = rawProgress.toFixed(4);
    }

    function requestRender() {
      if (!frame) frame = window.requestAnimationFrame(render);
    }

    function destroy() {
      window.removeEventListener('scroll', requestRender);
      window.removeEventListener('resize', requestRender);
      reducedMotion.removeEventListener('change', requestRender);
      if (frame) window.cancelAnimationFrame(frame);
      instances.delete(root);
    }

    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestRender);
    reducedMotion.addEventListener('change', requestRender);
    instances.set(root, { render: requestRender, destroy: destroy });
    render();
  }

  function boot(context) {
    var scope = context || document;
    if (scope.matches && scope.matches(selector)) createInstance(scope);
    scope.querySelectorAll(selector).forEach(createInstance);
  }

  function unload(event) {
    var roots = [];
    if (event.target.matches && event.target.matches(selector)) roots.push(event.target);
    event.target.querySelectorAll(selector).forEach(function (root) { roots.push(root); });
    roots.forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', unload);
})();
/** InsCoder WANG.J 2026-08-17 E + Why Shop at Ogee scroll reveal behavior **/
